import React, { useEffect, useMemo, useState, useCallback } from "react";
import moment from "moment";
import "moment/locale/fr";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { frCA } from "date-fns/locale";

import CardContact from "../../components/CardContact";
import CardInfoACompleter from "../../components/CardInfoACompleter";
import CardRdv from "../../components/CardRdv";
import CardAvancementDocument from "../../components/CardAvancementDocument";
import InfosBasiqueAffaire from "../../components/InfosBasiqueAffaire";

import ChoisirCreneauxRdv from "../newcalendar/ChoisirCreneauxRdv";
import { CalendarDaysIcon } from "@heroicons/react/16/solid";

// ✅ on réutilise ton composant d’affichage RDV
import RdvAffaireImmo from "../../components/RdvAffaireImmo";

registerLocale("fr", frCA);
moment.locale("fr");

function TabsAffaireInformations(args) {
  const { affaire, onOpenDocuments, onOpenMessagerie } = args;

  const [event, setEvent] = useState(null);
  const [action, setAction] = useState(null);
  const [rdv, setRdv] = useState(null);
  const [rdvNotaire, setRdvNotaire] = useState(null);
  const [demandeRdv, setDemandeRdv] = useState(null);

  const affaireId = affaire?.id;

  const airtableHeaders = {
    Authorization:
      "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
    Accept: "application/json",
  };

  // ✅ getEvent
  const getEvent = useCallback(async () => {
    if (!affaireId) return;

    try {
      const res = await fetch(
        `https://api.airtable.com/v0/appD48APNaGA4GN0B/event?filterByFormula=SEARCH("${affaireId}",{transaction})`,
        { headers: airtableHeaders }
      );

      if (!res.ok) {
        console.error("getEvent HTTP", res.status, await res.text());
        return;
      }

      const data = await res.json();
      setEvent(data.records ?? []);
    } catch (e) {
      console.error("getEvent error", e);
    }
  }, [affaireId]);

  // ✅ getRdv
  const getRdv = useCallback(async () => {
    if (!affaireId) return;

    const URL = `https://api.airtable.com/v0/appD48APNaGA4GN0B/rdv?filterByFormula=SEARCH("${affaireId}",{transaction})`;

    try {
      const res = await fetch(URL, { method: "GET", headers: airtableHeaders });

      if (!res.ok) {
        console.error("getRdv HTTP", res.status, await res.text());
        return;
      }

      const data = await res.json();
      const records = data.records ?? [];

      const sorted = [...records].sort((a, b) =>
        (a.fields?.sort ?? 999) < (b.fields?.sort ?? 999) ? -1 : 1
      );

      setRdv(sorted);

      const foundNotaire = records.find(
        (r) => r.fields?.nom === "Rendez-vous notaire"
      );
      setRvNotaireSafe(foundNotaire, setRdvNotaire);
    } catch (e) {
      console.error("getRdv error", e);
    }
  }, [affaireId]);

  // petit helper pour éviter de setter undefined
  function setRvNotaireSafe(found, setter) {
    setter(found ?? null);
  }

  // ✅ getDemandeRdv
  const getDemandeRdv = useCallback(async () => {
    if (!affaireId) return;

    const URL = `https://api.airtable.com/v0/appD48APNaGA4GN0B/demande_rdv?filterByFormula=SEARCH("${affaireId}",{id_affaire})`;

    try {
      const res = await fetch(URL, { method: "GET", headers: airtableHeaders });

      if (!res.ok) {
        console.error("getDemandeRdv HTTP", res.status, await res.text());
        return;
      }

      const data = await res.json();
      const records = data.records ?? [];

      const sorted = [...records].sort((a, b) =>
        (a.fields?.sort ?? 999) < (b.fields?.sort ?? 999) ? -1 : 1
      );

      setDemandeRdv(sorted);
    } catch (e) {
      console.error("getDemandeRdv error", e);
    }
  }, [affaireId]);

  // ✅ getActions
  const getActions = useCallback(async () => {
    if (!affaireId) return;

    const URL = `https://api.airtable.com/v0/appD48APNaGA4GN0B/actions?filterByFormula=SEARCH("${affaireId}",{transaction})`;

    try {
      const res = await fetch(URL, { method: "GET", headers: airtableHeaders });

      if (!res.ok) {
        console.error("getActions HTTP", res.status, await res.text());
        return;
      }

      const data = await res.json();
      setAction(data.records ?? []);
    } catch (e) {
      console.error("getActions error", e);
    }
  }, [affaireId]);

  useEffect(() => {
    if (!affaireId) return;
    getEvent();
    getRdv();
    getActions();
    getDemandeRdv();
  }, [affaireId, getEvent, getRdv, getActions, getDemandeRdv]);

  // ✅ on dérive les rdv “compromis” et “acte” à partir de rdv[]
  const rdvCompromis = useMemo(() => {
    if (!Array.isArray(rdv)) return null;
    return (
      rdv.find((r) => r.fields?.nom === "Signature - Compromis de vente") ?? null
    );
  }, [rdv]);

  const rdvActe = useMemo(() => {
    if (!Array.isArray(rdv)) return null;
    return (
      rdv.find(
        (r) => r.fields?.nom === "Signature - Acte authentique de vente"
      ) ?? null
    );
  }, [rdv]);
  const refreshAll = async () => {
  await Promise.all([getRdv(), getDemandeRdv(), getActions(), getEvent()]);
};

  moment.locale("fr");

  if (event !== null && rdv !== null && action !== null) {
    return (
      <>
        <InfosBasiqueAffaire type="immo" affaire={args.affaire} />

        {/* contact client */}
        <div className="">
          <h5 className="flex-auto truncate text-sm font-semibold leading-6 text-gray-700">
            <b>Contact(s) client</b>
          </h5>

          {args.affaire.acheteur && (
            <CardContact
              nom={args.affaire?.nom_from_acheteur?.[0] ?? ""}
              prenom={args.affaire?.prenom_from_acheteur?.[0] ?? ""}
              telephone={args.affaire?.telephone_from_acheteur?.[0] ?? ""}
              label="acheteur"
              onOpenMessagerie={onOpenMessagerie}
            />
          )}

          {args.affaire.vendeur && (
            <CardContact
              nom={args.affaire?.nom_from_vendeur?.[0] ?? ""}
              prenom={args.affaire?.prenom_from_vendeur?.[0] ?? ""}
              telephone={args.affaire?.telephone_from_vendeur?.[0] ?? ""}
              label="vendeur"
              onOpenMessagerie={onOpenMessagerie}
            />
          )}

          {args.affaire.partenaire && (
            <CardContact
              nom={args.affaire?.nom_from_partenaire?.[0] ?? ""}
              prenom={args.affaire?.prenom_from_partenaire?.[0] ?? ""}
              telephone={args.affaire?.telephone_from_partenaire?.[0] ?? ""}
              label="partenaire"
              onOpenMessagerie={onOpenMessagerie}
            />
          )}

          {args.affaire.agent && (
            <CardContact
              nom={args.affaire?.nom_from_agent?.[0] ?? ""}
              prenom={args.affaire?.prenom_from_agent?.[0] ?? ""}
              telephone={args.affaire?.telephone_from_agent?.[0] ?? ""}
              label="agent immobilier"
              onOpenMessagerie={onOpenMessagerie}
            />
          )}
        </div>

        {/* ✅ demande de rdv: inchangé */}
        <div className="mt-8">
          <h5 className="flex-auto truncate text-sm font-semibold leading-6 text-gray-700">
            <b>Demande de rendez-vous client</b>
          </h5>
          {demandeRdv?.length ? (
            <CardRdv
              date_creation={demandeRdv[0].fields?.date_creation}
              date={demandeRdv[0].fields?.date}
              heure_debut={demandeRdv[0].fields?.heure_debut}
              heure_fin={demandeRdv[0].fields?.heure_fin}
              type_rdv={demandeRdv[0].fields?.type}
              statut={demandeRdv[0].fields?.statut}
              id={demandeRdv[0].id}
            />
          ) : (
            <p className="text-sm text-gray-500">
              Aucune demande de rendez-vous prévu
            </p>
          )}
        </div>

        {/* ✅ AFFICHAGE RDV COMPROMIS + ACTE + NOTAIRE via RdvAffaireImmo */}
        <div className="mt-8">
          <h5 className="flex-auto truncate text-sm font-semibold leading-6 text-gray-700">
            <b>Rendez-vous de signature</b>
          </h5>

          <RdvAffaireImmo
            type="immobilier"
            idAffaire={affaireId}
            notaireAirtableId={args.affaire?.notaire?.[0] ?? null}
            rdvNotaire={rdvNotaire}
            rdvCompromis={rdvCompromis}
            rdvActe={rdvActe}
            refreshData={refreshAll}
          />
        </div>

        {/* documents */}
        <div className="mt-8">
          <h5 className="flex-auto truncate text-sm font-semibold leading-6 text-gray-700 mb-3">
            <b>Documents déposés</b>
          </h5>
          <CardAvancementDocument
            statut={
              action?.find((r) => r.fields?.nom === "Ajout document")?.fields
                ?.statut ?? "Non trouvé"
            }
            onOpenDocuments={onOpenDocuments}
          />
        </div>

        {/* questionnaire */}
        <div className="mt-8">
          <h5 className="flex-auto truncate text-sm font-semibold leading-6 text-gray-700">
            <b>Informations à compléter</b>
          </h5>

          {action
            .filter(
              (col) =>
                (col.fields?.nom || "").toLowerCase() !== "ajout document"
            )
            .slice()
            .sort(
              (a, b) =>
                Number(a.fields?.ordre ?? 999) - Number(b.fields?.ordre ?? 999)
            )
            .map((col) => (
              <CardInfoACompleter
                key={col.id}
                nom_document={col.fields?.nom}
                statut={col.fields?.statut}
                action_id={col.id}
                affaire={args.affaire}
              />
            ))}
        </div>

        {/* ✅ ta partie notaire “ancienne” est conservée si tu veux,
            mais tu peux la supprimer car RdvAffaireImmo affiche déjà tout.
            Je la laisse comme chez toi, mais avec className corrigés. */}
        {["Notaire acquéreur", "Notaire vendeur"].includes(
          args.affaire.info_notaire_role
        ) && (
          <>
            {rdvNotaire ? (
              <>
                {rdvNotaire.fields?.statut === "en cours de prog" && (
                  <div className="mt-2">
                    <h5 className="flex-auto truncate text-sm font-semibold leading-6 text-gray-700">
                      <b>Prise de rendez-vous</b>
                    </h5>
                    <p className="flex-auto truncate text-sm font-regular leading-6 text-gray-500 mb-3">
                      La prise de rendez-vous avec tous les acteurs n'est pas
                      possible car tous ne sont (malheureusement) pas sur
                      Clotere.
                    </p>
                    <div className="bg-white rounded-xl">
                      <div className="p-6 mx-auto lg:flex lg:items-center lg:justify-between lg:px-8">
                        <div>
                          <p className="text-lg font-bold tracking-tight text-gray-900">
                            Un rendez-vous est en cours de programmation
                          </p>
                          <p className="text-sm font-regular tracking-tight text-gray-500">
                            Votre client va bientôt confirmer le rendez-vous
                            parmi les 3 dates proposées
                          </p>
                          <ul className="space-y-2 flex flex-row items-center gap-4 flex-wrap">
                            <li className="bg-blue-100 text-blue-900 font-bold text-center py-3 px-4 rounded-md">
                              {rdvNotaire.fields?.dispo_notaire_1}
                            </li>
                            <li className="bg-blue-100 text-blue-900 font-bold text-center py-3 px-4 rounded-md">
                              {rdvNotaire.fields?.dispo_notaire_2}
                            </li>
                            <li className="bg-blue-100 text-blue-900 font-bold text-center py-3 px-4 rounded-md">
                              {rdvNotaire.fields?.dispo_notaire_3}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {rdvNotaire.fields?.statut === "programme" && (
                  <div className="mt-2">
                    <h5 className="flex-auto truncate text-sm font-semibold leading-6 text-gray-700">
                      <b>Prise de rendez-vous</b>
                    </h5>
                    <p className="flex-auto truncate text-sm font-regular leading-6 text-gray-500 mb-3">
                      La prise de rendez-vous avec tous les acteurs n'est pas
                      possible car tous ne sont (malheureusement) pas sur
                      Clotere.
                    </p>
                    <div className="bg-white rounded-xl">
                      <div className="p-6 mx-auto lg:flex lg:items-center lg:justify-between lg:px-8">
                        <div>
                          <p className="text-lg font-bold tracking-tight text-gray-900">
                            Rendez-vous confirmé
                          </p>
                          <ul className="space-y-2 flex flex-row items-center gap-4 flex-wrap">
                            <li className="bg-blue-100 text-blue-900 font-bold text-center py-3 px-4 rounded-md">
                              {rdvNotaire.fields?.dispo_notaire_1}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="mt-2">
                <h5 className="flex-auto truncate text-sm font-semibold leading-6 text-gray-700">
                  <b>Prise de rendez-vous</b>
                </h5>
                <p className="flex-auto truncate text-sm font-regular leading-6 text-gray-500 mb-3">
                  La prise de rendez-vous avec tous les acteurs n'est pas
                  possible car tous ne sont (malheureusement) pas sur Clotere.
                </p>
                <div className="bg-white p-6 rounded-lg">
                  <div className="flex flex-row gap-4 items-center justify-between">
                    <div className="flex-none">
                      <CalendarDaysIcon className="size-12 text-gray-400" />
                    </div>
                    <div className="flex-1">
                      <p className="text-lg font-bold tracking-tight text-gray-900">
                        Prenez rendez-vous avec votre client
                      </p>
                      <p className="text-sm font-regular tracking-tight text-gray-500">
                        Proposez trois créneaux. Vous serez notifié dès
                        confirmation.
                      </p>
                    </div>
                    <div className="mt-10 flex items-center gap-x-6 lg:mt-0 lg:shrink-0">
                      <ChoisirCreneauxRdv
                        id_transaction={args.affaire.id_transaction}
                        type="immobilier"
                        refreshData={getRdv}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </>
    );
  }

  return <></>;
}

export default TabsAffaireInformations;